module.exports = __webpack_public_path__ + "static/media/4-wheeler.c6d487d0.svg";